"use client"

import { sendBlockEvent } from "@/utils/gtm"
import styled from "@emotion/styled"
import { Box, Typography } from "@mui/material"
import Image from "next/image"
import { colors, mediaQueries, sizes } from "ui"
import { getNonUmbracoUrl } from "utils"
import { ButtonWithArrowTall } from "../common/bit/ButtonWithArrow"
import IconWithBackground from "../common/bit/IconWithBackground"

const StyledItemsIconsListWrapper = styled(Box)`
  display: flex;
  ${mediaQueries.mobile} {
    flex-direction: column;
    gap: ${sizes.baseTriple};
    align-items: center;
  }

  ${mediaQueries.tablet} {
    flex-direction: column;
    gap: ${sizes.baseTriple};
    align-items: center;
  }

  ${mediaQueries.desktopM} {
    flex-direction: row;
    gap: ${sizes.baseTriple};
    justify-content: center;
  }
`

const StyledButtonWithArrow = styled(ButtonWithArrowTall)`
  border-radius: ${sizes.baseSingle};
  gap: 10px;
  .content {
    flex-direction: row;
    text-align: start;
    gap: 10px;
  }
  .title {
    font-size: 18px;
    font-weight: 700;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  svg {
    width: unset;
  }
  ${mediaQueries.mobile} {
    width: 100%;
    height: 76px;
    justify-content: center;
    padding: 10px 8px 10px 12px;
    border-radius: ${sizes.borderRadius};
    > div {
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
    }

    div:last-child {
      margin-inline-start: auto;
    }
  }

  ${mediaQueries.tablet} {
    width: 100%;
    height: 76px;
    padding: 10px 8px 10px 12px;
    > div {
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
    }
    div:last-child {
      margin-inline-start: auto;
    }
  }

  ${mediaQueries.desktopM} {
    margin-bottom: 0px;
    width: 250px;
    height: 76px;
    padding: ${sizes.baseSingle};
    align-items: center;
    padding: 10px 8px 10px 12px;
  }

  ${mediaQueries.desktopXl} {
    width: 270px;
    height: 68px;
  }
`
interface IconsFormListProps {
  itemsList: {
    category?: string[]
    itemName?: string
    title?: string
    link?: { name: string; href: string }
    file?: { url: string }
    icon?: { id: number; url: string }
    primaryColor: string
  }[]
  data?: any
  id?: string
}

const IconsFormList: React.FC<React.PropsWithChildren<IconsFormListProps>> = ({
  itemsList,
  data,
  id,
}) => {
  return (
    <StyledItemsIconsListWrapper>
      {itemsList?.map((item, index) => {
        const { title, link, icon, primaryColor, file, itemName, category } =
          item

        const colorName = colors.resolveColorName("#" + primaryColor)
        const ArrowIcon = colors.getArrowIconNoLinesKey("#" + primaryColor)
        const onItemClick = () => {
          sendBlockEvent({
            blockId: id || "3",
            title: data?.title?.value,
            componentName: "טפסים",
            buttonName: title,
            actionName: undefined,
            productName: data?.formDefaultInsuranceType,
            serviceName: category?.[0] || undefined, // שם השרות
          })
        }
        return (
          <StyledButtonWithArrow
            key={`accordion-item-${title || itemName}-${index}`}
            arrowName={ArrowIcon}
            variant="elevated"
            colorPallette={colorName as any}
            href={getNonUmbracoUrl(file?.url || link?.href)}
            target="_blank"
            onClick={onItemClick}
          >
            {icon?.url && (
              <IconWithBackground
                icon={
                  icon.url && (
                    <Image src={icon.url} alt={link?.name || "icon"} fill />
                  )
                }
                backgroundColor={primaryColor}
              />
            )}
            {(itemName || link?.name) && (
              <Typography variant="h3" className="title">
                {itemName || link?.name}
              </Typography>
            )}
          </StyledButtonWithArrow>
        )
      })}
    </StyledItemsIconsListWrapper>
  )
}

export default IconsFormList
